import { combineReducers } from "redux";
import {
  DELETE_MESSAGE_DATA,
  COHORT_REQUEST_STARTUP_DASHBOARD,
  DASHBOARD_STARTUP_MYREQUEST,
  DASHBOARD_STARTUP_HOME,
  ALL_STARTUP_LIST,
  STARTUP_APPLICATIONS,
  VIEW_COUNTER_STARTUP_OPTIONS,
  SET_SELECTED_MENU,
  SESSIONS_SUMMARY_DATA,
  SESSIONS_SUMMARY_POST_DATA,
  SESSIONS_DELETE_DATA,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_LIST,
  POST_STARTUP_FEEDBACK,
  MENTOR_REQUEST_MENTORS_LIST,
  ENGAGEMENT_NOTES,
  UPLOAD_PROGRESS_REPORT,
  IM_SEND_MESSAGES,
  IM_ALL_MESSAGES,
  GET_STARTUP_FEEDBACK,
  SESSION_CALENDAR,
  GET_ENGAGEMENT_NOTES,
  MENTORSHIP_REQUESTS_COUNTER,
  NEW_MESSAGE_DISPLAY,
  NEW_SESSION_DISPLAY,
  MY_MENTORS_COUNTER,
  MY_STARTUPS_COUNTER,
  ALL_STARTUP_APPLICATION_LIST
} from "../../../../common/constants/actionConstants";

const getCohortForStartupList = (state = [], action) => {
  switch (action.type) {
    case COHORT_REQUEST_STARTUP_DASHBOARD:
      return { ...action.payload };
    default:
      return state;
  }
};
// const DashboardStartupMyRequestList = (state = [], action) => {
//   switch (action.type) {
//     case DASHBOARD_STARTUP_MYREQUEST:
//       return { ...action.payload };
//     default:
//       return state;
//   }
// };

// const DashboardStartupHomeList = (state = [], action) => {
//   switch (action.type) {
//     case DASHBOARD_STARTUP_HOME:
//       return { ...action.payload };
//     default:
//       return state;
//   }
// };
const AllStartUpList = (state = [], action) => {
  switch (action.type) {
    case ALL_STARTUP_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const AllStartUpApplicationList = (state = [], action) => {
  switch (action.type) {
    case ALL_STARTUP_APPLICATION_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const AllSessionCalendar = (state = [], action) => {
  switch (action.type) {
    case SESSION_CALENDAR:
      return { ...action.payload };
    default:
      return state;
  }
};
const StartUpApplications = (state = [], action) => {
  switch (action.type) {
    case STARTUP_APPLICATIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCountersStartUpList = (state = [], action) => {
  switch (action.type) {
    case VIEW_COUNTER_STARTUP_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getSummaryData = (state = [], action) => {
  switch (action.type) {
    case SESSIONS_SUMMARY_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const postSummaryData = (state = [], action) => {
  switch (action.type) {
    case SESSIONS_SUMMARY_POST_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const postStartupFeedback = (state = [], action) => {
  switch (action.type) {
    case POST_STARTUP_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const getStartupFeedback = (state = [], action) => {
  switch (action.type) {
    case GET_STARTUP_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const uploadDocument = (state = [], action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT:
      return { ...action.payload };
    default:
      return state;
  }
};
const uploadDocumentList = (state = [], action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const postEngagementNotes = (state = [], action) => {
  switch (action.type) {
    case ENGAGEMENT_NOTES:
      return { ...action.payload };
    default:
      return state;
  }
};
const getEngagementNotes = (state = [], action) => {
  switch (action.type) {
    case GET_ENGAGEMENT_NOTES:
      return { ...action.payload };
    default:
      return state;
  }
};

const postProgressReport = (state = [], action) => {
  switch (action.type) {
    case UPLOAD_PROGRESS_REPORT:
      return { ...action.payload };
    default:
      return state;
  }
};
const deleteSessionData = (state = [], action) => {
  switch (action.type) {
    case SESSIONS_DELETE_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const deleteMessageData = (state = [], action) => {
  switch (action.type) {
    case DELETE_MESSAGE_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const sendIMMessage = (state = [], action) => {
  switch (action.type) {
    case IM_SEND_MESSAGES:
      return { ...action.payload };
    default:
      return state;
  }
};
const allIMMessages = (state = [], action) => {
  switch (action.type) {
    case IM_ALL_MESSAGES:
      return { ...action.payload };
    default:
      return state;
  }
};
const selectedMenu = (state = "", action) => {
  switch (action.type) {
    case SET_SELECTED_MENU:
      return action.payload;
    default:
      return state;
  }
};
const startUpMentorshipCounter = (state = "", action) => {
  switch (action.type) {
    case MENTORSHIP_REQUESTS_COUNTER:
      return action.payload;
    default:
      return state;
  }
};
const myMentorsCounter = (state = "", action) => {
  switch (action.type) {
    case MY_MENTORS_COUNTER:
      return action.payload;
    default:
      return state;
  }
};
const myStartupsCounter = (state = "", action) => {
  switch (action.type) {
    case  MY_STARTUPS_COUNTER:
      return action.payload;
    default:
      return state;
  }
};
const getRequestfromMentorList = (state = [], action) => {
  switch (action.type) {
    case MENTOR_REQUEST_MENTORS_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};

const getNewMessages = (state = [], action) => {
  switch (action.type) {
    case NEW_MESSAGE_DISPLAY:
      return { ...action.payload };
    default:
      return state;
  }
};
const StartUpReducer = combineReducers({
  deleteMessageData,
  getCohortForStartupList,
  // DashboardStartupMyRequestList,
  // DashboardStartupHomeList,
  getCountersStartUpList,
  getRequestfromMentorList,
  AllStartUpList,
  AllSessionCalendar,
  StartUpApplications,
  selectedMenu,
  getSummaryData,
  postSummaryData,
  deleteSessionData,
  postStartupFeedback,
  uploadDocument,
  uploadDocumentList,
  postEngagementNotes,
  postProgressReport,
  allIMMessages,
  sendIMMessage,
  getStartupFeedback,
  getEngagementNotes,
  startUpMentorshipCounter,
  getNewMessages,
  myMentorsCounter,
  myStartupsCounter,
  AllStartUpApplicationList
});

export default StartUpReducer;
